"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Text = require("./Text");

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Text2.default;